import { render, staticRenderFns } from "./hdMember.vue?vue&type=template&id=2854649b&scoped=true&"
import script from "./hdMember.vue?vue&type=script&lang=js&"
export * from "./hdMember.vue?vue&type=script&lang=js&"
import style0 from "./hdMember.vue?vue&type=style&index=0&id=2854649b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2854649b",
  null
  
)

export default component.exports